

import { Component } from 'react';
import ReactDOM from 'react-dom';

class AnchoredComponent extends Component {

  componentDidMount() {
    if (location.hash) {
      const thisNode = ReactDOM.findDOMNode(this);
      if (thisNode) {
        const el = thisNode.querySelector(location.hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView();
          }, 200)
        }
      }
    }
  }

  componentDidUpdate(props) {

  }
}

export default AnchoredComponent;
